import React from 'react'
import PropTypes from 'prop-types'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import AchievementsSkeleton from './AchievementsSkeleton'

const AchievementsPlaceholder = ({
  progressSection,
  flashcardsSection,
  liveLessonSection,
  certSection,
  mediaSection,
  writingSection,
  conceptsSection,
  leaderboardSection,
}) => {
  return (
    <AchievementsSkeleton
      headerSection={<LoadingBox width="150px">&nbsp;</LoadingBox>}
      progressSection={progressSection}
      liveLessonSection={liveLessonSection}
      mediaSection={mediaSection}
      writingSection={writingSection}
      conceptsSection={conceptsSection}
      flashcardsSection={flashcardsSection}
      certSection={certSection}
      leaderboardSection={leaderboardSection}
    />
  )
}

AchievementsPlaceholder.propTypes = {
  progressSection: PropTypes.any,
  flashcardsSection: PropTypes.any,
  certSection: PropTypes.any,
  liveLessonSection: PropTypes.any,
  mediaSection: PropTypes.any,
  writingSection: PropTypes.any,
  conceptsSection: PropTypes.any,
  leaderboardSection: PropTypes.any,
}

export default AchievementsPlaceholder
